import { z } from 'zod';
export default {
  valueType: 'geoPoint',
  valueValidator: z.object({
    lat: z.number().min(-90).max(90),
    lon: z.number().min(-180).max(180)
  }).optional().nullable()
};